module.exports = __webpack_public_path__ + "static/img/loginindex3.bc621ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/loginindex3.png
// module id = 350
// module chunks = 0